import { AppBundle } from 'api/optimalprint-sdk.d';

type AbstractProductAttribute =
  AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.ProductItem.IAttribute;

const removeAttribute = (attributesOriginal: AbstractProductAttribute[], typeName: string) =>
  attributesOriginal.filter((attr) => attr.typeName !== typeName);

export default removeAttribute;
